<template>
  <ion-app>
    <ion-router-outlet />
  </ion-app>
</template>

<script>
import { defineComponent, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { delay, userApi, fddApi, fileApi } from '@/apis'
import file from './apis/file';


export default defineComponent({
  name: 'App',
  setup(props) {
    const store = new useStore()
    const testWsConnection = () => {
      try {
        const socket = new WebSocket('ws://121.199.14.45:8080/ws')
        socket.onopen = () => {
          console.log('[ws] Connected to ws://121.199.14.45:8080/ws')
          socket.send(
            JSON.stringify({
              type: 'ping',
              message: 'Connectivity test',
              timestamp: Date.now(),
            })
          )
        }
        socket.onmessage = event => {
          console.log('[ws] Message:', event.data)
        }
        socket.onerror = error => {
          console.error('[ws] Error:', error)
        }
        socket.onclose = event => {
          console.log('[ws] Closed:', event.code, event.reason)
        }
      } catch (error) {
        console.error('[ws] Initialization error:', error)
      }
    }
    

    onBeforeMount(async () => {
      fileApi.myFileUsedRecord({
        	"pageNum": 1,
	"pageSize": 15
      }).then(e => {
        console.log('eee',e);
        
      })
      testWsConnection()
      // const mobile = 18319064747
      // const name = '欧世豪'
      // const userIdentNo = '445321199204220319'
      // const upData = {
      //   "accountName": mobile,
      //   "authScopes": ["ident_info","seal_info","signtask_init","signtask_info","signtask_file","file_storage","billaccount_info"],
      //   "callbackUrl": "",
        
      //   "nonEditableInfo": [],
      //   "redirectMiniAppUrl": "",
      //   "redirectUrl": "",
      //   "unbindAccount": true,
      //   "userIdentInfo": {
      //     "bankAccountNo": "",
      //     "faceauthMode": "tencent",
      //     "identMethod": ["face"],
      //     "mobile": mobile,
      //     "nationalityCode": "",
      //     "userIdentNo": userIdentNo,
      //     "userIdentType": "id_card",
      //     "userName": name
      //   }
      // }
      // const data = await fddApi.personUser({
      //   ...upData
      // })
      // console.log('--personUser--', data)
      if (store.getters['user/token']) {
        store.dispatch('dict/getDict')
        store.dispatch('user/getInfo')
      }
    })
    return {}
  },
})
</script>

<style lang="scss">
@import 'sass/adjustment.element.scss';
@import 'sass/common.scss';
@import 'sass/config.scss';
@import 'sass/font.scss';
@import 'sass/utils.scss';
@import 'sass/imageSize.scss';
@import 'sass/width.scss';
@import 'sass/flex.scss';
@import 'sass/margin.scss';
@import 'sass/padding.scss';
@import 'sass/pc-input.scss';

body {
  font-size: 26px;
  color: #333;
}
input {
  -webkit-appearance: none;
  outline: none;
}
</style>
